import { useState } from 'react';
import { AuditLogs } from '@/components/admin/audit/audit-logs';
import type { AuditLog } from '@/lib/types';

// Mock audit log data
const mockAuditLogs: AuditLog[] = [
  {
    id: '1',
    timestamp: '2024-01-15T10:00:00Z',
    action: 'user.login',
    userId: '1',
    userRole: 'admin',
    details: {
      ip: '192.168.1.1',
      browser: 'Chrome',
    },
  },
  {
    id: '2',
    timestamp: '2024-01-15T09:30:00Z',
    action: 'settings.update',
    userId: '1',
    userRole: 'admin',
    details: {
      setting: 'email_notifications',
      oldValue: 'false',
      newValue: 'true',
    },
  },
];

export function AuditPage() {
  const [logs] = useState(mockAuditLogs);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">Audit Logs</h1>
      <AuditLogs logs={logs} />
    </div>
  );
}